export interface WarningMessageData {
  messageId?: string;
  apiErrorCode?: string;
  interpolateParams?: Object;
}
export interface ServiceRequestCompletedState {
  nextAction?: string;
  warningMessageList?: Array<WarningMessageData>;
  paymentInfo?: {
    purchaseResults?: string;
    is3DSecureApplied?: boolean;
    paymentMethod?: string;
  };
}

export const SERVICE_REQUEST_COMPLETED = 'serviceRequestCompleted';

export interface ServiceRequestCompletedStore {
  [SERVICE_REQUEST_COMPLETED]: ServiceRequestCompletedState;
}
